<template>
  <div>
    <v-row>
      <v-col v-if="$auth.policies['view-teaching-list']">
        <v-card outlined>
          <v-card-title class="d-flex justify-space-between">
            Công tác giảng dạy
            <v-btn
              v-if="$auth.policies['add-new-teaching']"
              class="mr-2"
              depressed
              outlined
              color="primary"
              @click="addCore = !addCore"
              :block="$vuetify.breakpoint.smAndDown"
            >
              <v-icon left>add</v-icon>
              Phân công lớp học
            </v-btn></v-card-title
          >
          <v-divider />
          <v-card-text>
            <h1 class="text-center py-3" style="color: #46be8a">{{ teachingClassCount }}</h1>
            <div class="text-center pb-3">Số lớp đang dạy</div>
          </v-card-text>
          <v-data-table
            v-if="teachings.length"
            mobile-breakpoint="0"
            item-key="id"
            hide-default-footer
            :headers="teachingHeaders"
            :items="teachings"
            :loading="teachingLoading"
            :items-per-page="-1"
          >
            <template v-slot:[`item.class.title`]="{ item }">
              <router-link
                v-if="$auth.policies['view-class']"
                style="text-decoration: none"
                :to="'/class/' + (item.class && item.class.id)"
              >
                <span v-if="item.class">{{ item.class && item.class.title }}</span>
              </router-link>
              <div v-else>
                <span v-if="item.class">{{ item.class && item.class.title }}</span>
              </div>
            </template>
            <template v-slot:[`item.updatedAt`]="{ item }">
              {{ item.updatedAt | ddmmyyyy }}
            </template>
            <template v-slot:[`item.grade`]="{ item }"> {{ item.grade.code }} - {{ item.grade.title }} </template>
            <template v-slot:[`item.action`]="{ item }">
              <TeachingListAction :selectedTeaching="item" @updateDone="updateTeachingDone" />
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" v-else> </v-col>
      <v-col cols="12" md="12" :style="{ padding: '0px' }">
        <v-col cols="12" md="12">
          <v-card outlined>
            <v-card-title :style="{ margin: '0px', padding: '16px' }">
              <div class="bold-text">Lịch dạy</div>
              <div class="py-3 px-0" :style="{ width: '100%' }">
                <v-divider :style="{ width: '100%' }"></v-divider>
              </div>
              <div class="d-flex justify-space-between" :style="{ width: '100%' }">
                <v-btn class="my-2" outlined color="primary" @click="previousWeek">
                  <v-icon size="24">mdi-chevron-left</v-icon>
                  <span>{{ 'Tuần trước' }}</span>
                </v-btn>
                <div class="d-flex align-center mx-3 text-subtitle-1">
                  <div class="mr-1">
                    {{ 'Tuần từ:' }}
                  </div>
                  <div class="bold-text">{{ startOfWeek }}</div>
                  <div class="mx-2">{{ 'đến' }}</div>
                  <div class="bold-text">{{ endOfWeek }}</div>
                </div>
                <v-btn class="my-2" outlined color="primary" @click="nextWeek">
                  <span>{{ 'Tuần sau' }}</span>
                  <v-icon size="24">mdi-chevron-right</v-icon>
                </v-btn>
              </div>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <div class="ma-4">
                <StudentCalendar :calendarLoading="calendarLoading" :isHideAttendance="true" />
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-col>

      <v-col cols="12" md="12">
        <v-card outlined>
          <v-card-title> Sổ sách giảng dạy </v-card-title>
          <v-divider />

          <v-data-table
            no-data-text="Không có dữ liệu"
            mobile-breakpoint="0"
            item-key="id"
            hide-default-footer
            :headers="documentHeaders"
            :items="documents"
            :loading="documentLoading"
            :items-per-page="-1"
          >
            <template v-slot:[`item.type`]="{ item }">
              {{ item.documentType.title }}
            </template>
            <template v-slot:[`item.title`]="{ item }">
              <div @click="item.file ? openLink(item.file) : null" style="color: #1a0dab; cursor: pointer">
                {{ item.file && item.file.name }}
              </div>
            </template>
            <template v-slot:[`item.createdAt`]="{ item }">
              {{ item.createdAt | ddmmyyyy }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>

      <v-col cols="12">
        <TeacherSalaryConfig />
      </v-col>
    </v-row>

    <TeachingNewDialog
      :showTeacher="true"
      :showAssistant="true"
      :defaultTeacher="teacher"
      :state="addCore"
      @done="teachingRefresh"
    />
    <ExtraTeachingNewDialog :state="addExtra" :defaultTeacher="teacher" @done="teachingRefresh" />
    <OwnClassTeacherNewDialog :state="addState" :defaultTeacher="teacher" @done="headTeacherAdded" />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import TeachingListAction from '@/modules/teacher/TeachingListAction.vue'
import OwnClassListAction from '@/modules/teacher/OwnClassListAction.vue'
import ExtraTeachingNewDialog from '@/modules/teacher/ExtraTeachingNewDialog.vue'
import TeachingNewDialog from '@/modules/teacher/TeachingNewDialog'
import OwnClassTeacherNewDialog from '@/modules/teacher/OwnClassTeacherNewDialog'
import TeacherSalaryConfig from './TeacherSalaryConfig.vue'
import StudentCalendar from '../../../views/student/components/StudentCalendar.vue'
import moment from 'moment'

export default {
  components: {
    TeachingListAction,
    OwnClassListAction,
    ExtraTeachingNewDialog,
    TeachingNewDialog,
    OwnClassTeacherNewDialog,
    TeacherSalaryConfig,
    StudentCalendar,
  },
  data() {
    return {
      isTeacher: false,
      addCore: false,
      addExtra: false,
      addState: false,
      ownClassTeacherLoading: false,
      teachingLoading: false,
      documentLoading: false,
      selectedTeaching: null,
      deleteState: false,
      editState: false,
      selectedOwnClass: null,
      editOwnClassState: false,
      teachingHeaders: [
        {
          text: 'Bộ môn',
          value: 'academicLevel.title',
          align: 'left',
          sortable: false,
          show: true,
          width: 200,
        },
        {
          text: 'Chương trình đào tạo',
          value: 'division.title',
          align: 'left',
          sortable: false,
          show: true,
          width: 200,
        },
        {
          text: 'Học phần',
          value: 'grade',
          align: 'left',
          sortable: false,
          show: true,
          width: 200,
        },
        {
          text: 'Lớp',
          value: 'class.title',
          align: 'left',
          sortable: false,
          show: true,
        },
        {
          text: 'Bộ môn',
          value: 'subjectGroup.title',
          align: 'left',
          sortable: false,
          show: true,
        },
        {
          text: 'Từ ngày',
          align: 'left',
          value: 'updatedAt',
          sortable: false,
          show: true,
        },
        {
          text: 'Thao tác',
          align: 'center',
          value: 'action',
          sortable: false,
          show: true,
          width: 100,
        },
      ],
      ownClassHeaders: [
        {
          text: 'Học phần',
          value: 'grade.gradeNumber',
          align: 'left',
          sortable: false,
          show: true,
          width: 50,
        },
        {
          text: 'Lớp',
          value: 'title',
          align: 'left',
          sortable: false,
          show: true,
        },
        {
          text: 'Số học viên',
          value: 'studentNum',
          align: 'left',
          sortable: false,
          show: true,
        },
        {
          text: 'Từ ngày',
          value: 'fromDate',
          align: 'left',
          sortable: false,
          show: true,
        },
        {
          text: 'Thao tác',
          value: 'action',
          align: 'left',
          sortable: false,
          show: true,
        },
      ],
      documentHeaders: [],
      calendarLoading: false,
      currentDate: null,
      startOfWeek: '',
      endOfWeek: '',
    }
  },
  props: {},
  computed: {
    ...mapState('teacher', ['teacher', 'teachings', 'ownClasses', 'teachingClassCount', 'documents']),
    ...mapGetters('app', ['currentSchoolYear']),
    ...mapGetters('auth', ['profile', 'role']),
  },
  methods: {
    ...mapActions('teacher', [
      'fetchTeachings',
      'updateTeaching',
      'removeTeaching',
      'fetchOwnClasses',
      'updateTeachingList',
      'updateOwnClassList',
      'fetchTeacherDocuments',
    ]),
    ...mapActions('ownClassTeacher', ['updateMessageGroup']),
    ...mapActions({
      findTimeTable: 'lessonAttendance/findTimeTable',
    }),

    updateTeachingDone(teaching) {
      this.updateTeachingList(teaching)
    },
    updateOwnClasDone(classData) {
      this.updateOwnClassList(classData)
    },
    async teachingRefresh() {
      this.teachingLoading = true
      const teachers = await this.fetchTeachings({ teachers: this.teacher.id })
      if (teachers.length) this.isTeacher = true
      if (!this.isTeacher) await this.fetchTeachings({ assistants: this.teacher.id })
      this.teachingLoading = false
    },
    async ownClassTeacherRefresh() {
      this.ownClassTeacherLoading = true
      await this.fetchOwnClasses({ teacher: this.teacher.id })
      this.ownClassTeacherLoading = false
    },
    async documentRefresh() {
      this.documentLoading = true
      await this.fetchTeacherDocuments({ createdTeacher: this.teacher.id })
      this.documentLoading = false
    },
    async headTeacherAdded(classData) {
      // update header teacher => update message group
      await this.updateMessageGroup({
        classData,
      })
      await this.ownClassTeacherRefresh()
    },
    openLink(file) {
      if (file && file.url) window.open(file.url, '_blank')
    },
    async previousWeek() {
      if (this.currentDate === null) this.$alert.error('Đang tải dữ liệu, Vui lòng đợi')
      const newDate = moment(this.currentDate).subtract(7, 'days').toISOString()
      await this.getTeacherCalendar(newDate)
    },
    async nextWeek() {
      if (this.currentDate === null) this.$alert.error('Đang tải dữ liệu, Vui lòng đợi')
      const newDate = moment(this.currentDate).add(7, 'days').toISOString()
      await this.getTeacherCalendar(newDate)
    },
    async getTeacherCalendar(date = null) {
      this.calendarLoading = true
      try {
        let selectedDate = null
        if (!date) selectedDate = moment().toISOString()
        else selectedDate = date
        await this.findTimeTable({ type: 'teacher', id: this.teacher.id, date: selectedDate })
        this.currentDate = selectedDate
        this.startOfWeek = moment(selectedDate).startOf('week').format('DD/MM')
        this.endOfWeek = moment(selectedDate).endOf('week').format('DD/MM')
      } catch (error) {
        console.log(error)
        this.$alert.error('Không tải được thời khoá biểu')
      } finally {
        this.calendarLoading = false
      }
    },
  },

  async created() {
    if (this.role.type === 'inspector') {
      this.documentHeaders = [
        {
          text: 'Thư mục',
          value: 'type',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Tên tài liệu',
          value: 'title',
          align: 'left',
          sortable: false,
        },
      ]
    } else {
      this.documentHeaders = [
        {
          text: 'Thư mục',
          value: 'type',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Tên tài liệu',
          value: 'title',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Ngày tạo',
          value: 'createdAt',
          align: 'left',
          sortable: false,
        },
      ]
    }

    await Promise.all([this.teachingRefresh(), this.ownClassTeacherRefresh()])
    await this.getTeacherCalendar()
  },
}
</script>
<style lang="scss" scoped>
.bold-text {
  font-weight: 500;
  font-size: 20px;
  margin-bottom: 1px;
}
</style>
